import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/*
!!! ATTENTION !!!
Original file: packages/ab-common/src/components/LoadingOverlay/index.tsx

Delete this file and import the version from ui-utils when
it is ready to be consumed.

The file may have been modified since it was first copied
from ab-common. Please ensure that the replacement has
all of the required functionality before using it.
*/

import React from 'react';
import FontAwesome from 'react-fontawesome';
import _LoadingOverlay from "./style";
var LoadingOverlay = function LoadingOverlay(props) {
  return /*#__PURE__*/React.createElement(_LoadingOverlay, _extends({
    "data-testid": "loading-overlay"
  }, props), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "circle-o-notch",
    spin: true
  })));
};
export default LoadingOverlay;